export const getDeliveredRange = (package_percents) =>
	package_percents
		.sort(
			(packagePercentA, packagePercentB) =>
				packagePercentA.percents - packagePercentB.percents,
		)
		.map((packagePercent) => packagePercent.percents);
